// Generated by genversion.
export const version = '4.22.1';
